module.exports = __webpack_public_path__ + "static/media/support.b70438c0.svg";